export const chainId: '0x38' | '0x61' = '0x38'; // 38 - prod / 61 - test / 1 for eth prod
export const show_settings = true;
export const basename = 'dapp';
export const send_error_msg = true;
export const project_name = 'LST';
export const token1 = 'BTC';
export const token2 = 'USDT';
export const leverage = 3;

export const whiteList = [
  '0x20cB6fe009479F5eEE7640d179ab958b3A93492E',
  '0xCA9c30daaC90c7b55A36Fc94031f972D8E3CFbD4',
  '0xACC084e04b1fA9E33842B7897753A821581e7795'
]